import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-events-slider',
    templateUrl: './events-slider.component.html',
    styleUrls: ['./events-slider.component.scss'],
    standalone: false
})
export class EventsSliderComponent implements OnInit {

  @Output() selectedNewEvent = new EventEmitter<string>();
  selectedEventNumber = 5;
  constructor() { }

  ngOnInit(): void {
    // this.selectedEvent(5);
  }

  selectedEvent(selectedEvent: number): void {
    this.selectedEventNumber = selectedEvent;
    this.selectedNewEvent.emit(selectedEvent.toString());
  }

  changeSlider(slider: number): void {
    this.selectedEventNumber = this.selectedEventNumber + slider;
    const element = document.getElementById('cardEvent' + this.selectedEventNumber);
    if (element) {
      element.click();
    }
  }

}
